import { useSubscriptionPlan } from "./useSubscriptionPlan";

export function useIsPro(): boolean {
  return useSubscriptionPlan() !== "free";
}
